<template>
  <ModalStructure
    @close="$emit('close')"
    :loading="updatePageLoading"
    :nopadding="true"
  >
    <div slot="title">Page: {{ page.name }}</div>
    <div slot="body">
      <v-alert type="info" border="left" text class="ma-2"
        >After changing page config, publish your website to see updated
        changes.</v-alert
      >
      <SettingsRow title="Page Name">
        <div slot="left">
          <v-text-field
            label="Page name"
            placeholder="Page name"
            autocomplete="off"
            outlined
            dense
            v-model="page.name"
            @input="
              UPDATE_PAGE_PROP({
                prop: ['name'],
                value: $event,
              });
              onInputUpdatePage(page);
            "
          ></v-text-field>
        </div>
        <div slot="right">
          Give your page a name to identify in your project. Only you can see
          it.
        </div>
      </SettingsRow>
      <v-divider></v-divider>
      <SettingsRow title="Page URL">
        <div slot="left">
          <v-text-field
            type="text"
            label="Page url"
            placeholder="Page url"
            autocomplete="off"
            outlined
            dense
            v-model="page.url"
            @input="
              UPDATE_PAGE_PROP({
                prop: ['url'],
                value: $event,
              });
              onInputUpdatePage(page);
            "
            :disabled="!page.canDelete"
            class="mt-2"
          ></v-text-field>
          <small
            >URL will be: {{ selectedProject.computedDomain + page.url }}</small
          >
        </div>
        <div slot="right">
          URL of your page. It must start with a slash ( <strong>/</strong> ).
        </div>
      </SettingsRow>
      <v-divider></v-divider>
      <SettingsRow title="Title">
        <div slot="left">
          <v-text-field
            type="text"
            label="Title"
            placeholder="Title"
            autocomplete="off"
            outlined
            dense
            v-model="page.pageConfig.title"
            @input="
              UPDATE_PAGE_PROP({
                prop: ['pageConfig', 'title'],
                value: $event,
              });
              onInputUpdatePage(page);
            "
          ></v-text-field>
        </div>
        <div slot="right">
          Title of your page, it will shown in the browser title and search
          engine results.
        </div>
      </SettingsRow>
      <v-divider></v-divider>
      <SettingsRow title="SEO Description">
        <div slot="left">
          <v-text-field
            type="text"
            label="Description"
            placeholder="SEO Description"
            autocomplete="off"
            outlined
            dense
            v-model="page.pageConfig.description"
            @input="
              UPDATE_PAGE_PROP({
                prop: ['pageConfig', 'description'],
                value: $event,
              });
              onInputUpdatePage(page);
            "
          ></v-text-field>
        </div>
        <div slot="right">
          SEO description of your page. It'll improve your pages visibility in
          search engine results.
        </div>
      </SettingsRow>
      <v-divider></v-divider>
      <SettingsRow title="SEO Keywords">
        <div slot="left">
          <v-text-field
            type="text"
            label="Keywords"
            placeholder="SEO Keywords"
            autocomplete="off"
            outlined
            dense
            v-model="page.pageConfig.keywords"
            @input="
              UPDATE_PAGE_PROP({
                prop: ['pageConfig', 'keywords'],
                value: $event,
              });
              onInputUpdatePage(page);
            "
          ></v-text-field>
        </div>
        <div slot="right">
          SEO keywords of your page. It'll improve your pages visibility in
          search engine results.
        </div>
      </SettingsRow>
      <v-divider></v-divider>
      <SettingsRow title="Delete This Page" v-if="page.canDelete">
        <div slot="left">
          <v-btn @click="tryDeletePage(page)" small color="error" outlined
            >Delete this page</v-btn
          >
        </div>
      </SettingsRow>
    </div>
  </ModalStructure>
</template>

<script>
import projectMixin from "./project-mixin";

export default {
  mixins: [projectMixin],
  props: ["page"],
  methods: {
    async tryDeletePage() {
      if (confirm("Delete this page?")) {
        await this.deletePage(this.page);
        this.$emit("close");
        this.broadcastPageDeleted();
      }
    },
  },
};
</script>

<style scoped>
</style>